module.exports = __webpack_public_path__ + "img/106.0844f27d.jpg";